import { Navbar } from '../home/components/Navbar';
import { Footer } from '../home/components/Footer';

export default function ShippingPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      {/* Hero */}
      <section className="relative pt-32 pb-20 px-6 bg-gradient-to-br from-[#6B0000] to-[#4A0000]">
        <div className="max-w-7xl mx-auto text-center">
          <span className="inline-block px-4 py-1.5 bg-white/10 text-white text-xs font-bold uppercase tracking-widest rounded-full mb-6">
            Delivery Info
          </span>
          <h1 className="text-5xl md:text-6xl font-black text-white mb-6">
            Shipping &amp; Delivery
          </h1>
          <p className="text-xl text-white/90 max-w-2xl mx-auto">
            Fast, reliable shipping from Starkville to your door
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-20 px-6">
        <div className="max-w-4xl mx-auto space-y-12">
          {/* Turnaround Time */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-12 h-12 flex items-center justify-center bg-red-50 rounded-lg flex-shrink-0">
                <i className="ri-time-line text-2xl text-[#6B0000]"></i>
              </div>
              <div>
                <h2 className="text-2xl font-black text-gray-900 mb-2">
                  Production Time
                </h2>
                <p className="text-sm text-gray-600">
                  Most custom orders are printed and ready within <strong className="text-gray-900">48 hours</strong> of order placement. During peak seasons (game days, holidays), production may take up to 3-4 business days.
                </p>
              </div>
            </div>
            <div className="bg-red-50 rounded-lg p-4">
              <p className="text-sm font-bold text-[#6B0000]">
                <i className="ri-information-line mr-2"></i>
                Rush orders available! Contact us for same-day or next-day printing.
              </p>
            </div>
          </div>

          {/* Shipping Rates */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-12 h-12 flex items-center justify-center bg-red-50 rounded-lg flex-shrink-0">
                <i className="ri-truck-line text-2xl text-[#6B0000]"></i>
              </div>
              <div>
                <h2 className="text-2xl font-black text-gray-900 mb-2">
                  Shipping Rates
                </h2>
                <p className="text-sm text-gray-600 mb-6">
                  We offer multiple shipping options to fit your timeline and budget.
                </p>
              </div>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-gray-200">
                    <th className="text-left py-3 px-4 font-black text-gray-900">Shipping Method</th>
                    <th className="text-left py-3 px-4 font-black text-gray-900">Delivery Time</th>
                    <th className="text-left py-3 px-4 font-black text-gray-900">Cost</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  <tr>
                    <td className="py-4 px-4 font-semibold text-gray-900">Standard Shipping</td>
                    <td className="py-4 px-4 text-gray-600">3-5 business days</td>
                    <td className="py-4 px-4 text-gray-900">
                      <strong>FREE</strong> on orders $50+<br />
                      <span className="text-sm text-gray-500">$5.99 under $50</span>
                    </td>
                  </tr>
                  <tr>
                    <td className="py-4 px-4 font-semibold text-gray-900">Express Shipping</td>
                    <td className="py-4 px-4 text-gray-600">2-3 business days</td>
                    <td className="py-4 px-4 text-gray-900">$12.99</td>
                  </tr>
                  <tr>
                    <td className="py-4 px-4 font-semibold text-gray-900">Overnight Shipping</td>
                    <td className="py-4 px-4 text-gray-600">1 business day</td>
                    <td className="py-4 px-4 text-gray-900">$24.99</td>
                  </tr>
                  <tr className="bg-red-50">
                    <td className="py-4 px-4 font-semibold text-[#6B0000]">Local Pickup (Starkville)</td>
                    <td className="py-4 px-4 text-gray-900">Same day / Next day</td>
                    <td className="py-4 px-4 font-black text-[#6B0000]">FREE</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Local Pickup */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-12 h-12 flex items-center justify-center bg-red-50 rounded-lg flex-shrink-0">
                <i className="ri-store-2-line text-2xl text-[#6B0000]"></i>
              </div>
              <div>
                <h2 className="text-2xl font-black text-gray-900 mb-2">
                  Local Pickup in Starkville
                </h2>
                <p className="text-sm text-gray-600 mb-4">
                  Skip shipping costs and pick up your order at our Starkville shop! Select "Local Pickup" at checkout and we'll notify you when your order is ready.
                </p>
                <div className="space-y-2 text-sm">
                  <p className="text-gray-900">
                    <strong>Location:</strong> 123 Main Street, Starkville, MS 39759
                  </p>
                  <p className="text-gray-900">
                    <strong>Pickup Hours:</strong> Mon-Fri 9am-6pm, Sat 10am-4pm
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Tracking */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 flex items-center justify-center bg-red-50 rounded-lg flex-shrink-0">
                <i className="ri-map-pin-line text-2xl text-[#6B0000]"></i>
              </div>
              <div>
                <h2 className="text-2xl font-black text-gray-900 mb-2">
                  Order Tracking
                </h2>
                <p className="text-sm text-gray-600 mb-4">
                  Once your order ships, you'll receive a tracking number via email. Track your package in real-time from our shop to your door.
                </p>
                <p className="text-sm text-gray-600">
                  Questions about your order? Email us at <a href="mailto:hello@ontargetprints.com" className="font-bold text-[#6B0000] hover:underline cursor-pointer">hello@ontargetprints.com</a>
                </p>
              </div>
            </div>
          </div>

          {/* International */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 flex items-center justify-center bg-red-50 rounded-lg flex-shrink-0">
                <i className="ri-global-line text-2xl text-[#6B0000]"></i>
              </div>
              <div>
                <h2 className="text-2xl font-black text-gray-900 mb-2">
                  International Shipping
                </h2>
                <p className="text-sm text-gray-600">
                  We currently ship within the United States only. International shipping is coming soon! Contact us if you have special shipping needs.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}